module.exports = __webpack_public_path__ + "img/ens.4185bca7.svg";